/*
 * @Author: tianzhitong laotianwy@163.com
 * @Date: 2024-04-14 15:39:19
 * @LastEditors: tianzhitong laotianwy@163.com
 * @LastEditTime: 2024-04-16 15:50:54
 * @FilePath: /seller-station-client/src/atom/user.ts
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import { subscribe } from '@sniff/routeguard';
import { atom } from 'jotai';
import {
	CustomerDetailRespDTO,
	CustomerOverviewRespDTO
} from '@/service/customer';
import { request } from '@/config/request';
import { asyncData } from './_base';
import { rateInfo } from './rate';
import { cartNum } from './cart/cart';
const tokenKey = '_seller_station_auth_token_';

const local = localStorage.getItem(tokenKey) ?? '';

export const useToken = subscribe(local);
export const getToken = () => useToken.getState();
export const setToken = (next) => {
	useToken.setState(next);
	localStorage.setItem(tokenKey, getToken());
};

interface UserInfo extends CustomerDetailRespDTO {}

export const userInfo = asyncData({
	/** 请求用户信息 */
	get: async () => {
		const token = getToken();
		if (!token) return undefined;
		const res = await request.customer.getCustomerDetail
			.getCustomerDetail({ token })
			.catch(() => {
				setToken('');
				return undefined;
			});
		if (res?.data?.customerId) {
			rateInfo.update();
			cartNum.update();
		}
		return res?.data;
	},
	set: async () => {},
	/** 获取店铺id */
	shopId(store, payload) {
		return store.getState()?.customerShopList?.[0]?.customerShopId;
	},
	/** 获取用户戏 */
	async getUserInfo({ getState, get }) {
		if (getState()?.customerId) {
			return getState();
		}
		return get();
	}
});
